// src/lib/emailSuggest.js
// "Bedoelt u jan@gmail.com?" — typfout-hulp voor e-mailvelden. Stelt alleen voor,
// verandert het adres nooit zelf. Logica 1:1 uit keukeninbeeld intake.js.

export const MAIL_DOMAINS = [
  'gmail.com', 'hotmail.com', 'hotmail.nl', 'outlook.com', 'outlook.nl', 'live.nl', 'live.com',
  'icloud.com', 'me.com', 'yahoo.com', 'ziggo.nl', 'kpnmail.nl', 'kpnplanet.nl', 'planet.nl', 'home.nl', 'xs4all.nl',
  'telfort.nl', 'upcmail.nl', 'casema.nl', 'chello.nl', 'msn.com', 'protonmail.com', 'proton.me',
];

function distance(a, b) {
  let prev = [];
  for (let j = 0; j <= b.length; j++) prev[j] = j;
  for (let i = 1; i <= a.length; i++) {
    const row = [i];
    for (let j = 1; j <= b.length; j++) {
      row[j] = Math.min(prev[j] + 1, row[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
    }
    prev = row;
  }
  return prev[b.length];
}

/** Voorgesteld adres, of '' als er niets te corrigeren valt. */
export function emailSuggestion(address) {
  const m = /^([^@\s]+)@([^@\s]+)$/.exec(String(address || '').trim().toLowerCase());
  if (!m) return '';
  const domain = m[2].replace(/\.+$/, '');
  if (MAIL_DOMAINS.includes(domain)) return '';
  // Kort domein: max. één letter verschil, anders wordt live.be ten onrechte live.nl.
  let best = '';
  let min = domain.length >= 9 ? 3 : 2;
  for (const known of MAIL_DOMAINS) {
    const d = distance(domain, known);
    if (d < min) { min = d; best = known; }
  }
  if (!best) {
    const tld = domain.replace(/\.(con|cmo|ocm|vom|xom|co|om)$/, '.com').replace(/\.(nll|nk|bl|ml)$/, '.nl');
    if (tld !== domain) best = tld;
  }
  return best ? `${m[1]}@${best}` : '';
}

/** Alleen het domein van een adres — het enige dat in events mag (geen PII). */
export function domainOf(address) {
  return String(address || '').split('@')[1] || '';
}
